export default __webpack_public_path__ + "static/media/08.39b27bc5.jpg";